import { Theme } from 'config';

const styles = (theme: Theme) => ({
  container: {
    padding: '4rem',
    backgroundColor: '#fff',
    borderRadius: '0.25em',
    boxShadow:
      '0 0.0625em 0 0 rgba(0,0,0,0.03), 0 0.125em 0.375em 0 rgba(0,0,0,0.06);',
  },
  breadcrumb: {
    margin: '8rem auto 1rem auto',
  },
  chartPlaceholder: {
    boxShadow: 'none',
  },
  mainHeader: {
    color: '#585858 !important',
    fontSize: '1.125em !important',
    background: '#f7f7f7',
  },
  table: { width: '100% !important' },
  header: {
    color: theme.violet,
    marginLeft: '.5rem',
    fontWeight: 500,
    width: '100%',

    '&.sub': {
      marginTop: 0,
      color: theme.darkGray,
    },
  },
  parameter: {
    fontSize: '0.9em !important',
    marginLeft: '.5rem !important',
    color: `${theme.darkGray} !important`,
    padding: '0 !important',
    fontWeight: 500,
  },
});

export default styles;
